import LogoNoText from "../components/Logos/Logo_NoText";

export default function Header(props) {
  return (
    <header
      className={`d-flex align-items-center flex-column justify-content-center p-3 ${props.className || ""}`}
      style={{ marginLeft: "10rem" }}
    >
      {/* LOGO AREA */}
      <div
        className="position-absolute top-0 start-0"
        style={{ margin: "2.5rem 0 0 2.5rem" }}
      >
        <LogoNoText />
      </div>
      {/* HEADER TEXT */}
      <div className="d-flex flex-column align-items-center justify-content-center">
        {/* H1 AREA */}
        <h1 className="fw-bold text-uppercase lh-sm main-disbound-header m-0">
          Disbound
        </h1>
        {/* h2 AREA */}
        <h2
          id="pageName"
          className="inline-block letter-spacing  text-uppercase text-center heading-secondary m-0 background-main-purple "
          style={{
            fontSize: "1.2rem",
          }}
        >
          {props.pageH1}
        </h2>
      </div>
    </header>
  );
}
